import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleSlideshow extends Icon {
  static defaultProps = {
    color: '#FFFFFF',
    size: 16,
    viewPortSize: 21
  };
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <g>
            <path
              d="M17.7,12.6V2.6l-0.3-0.3H3.6L3.3,2.6v10.1l0.3,0.3h13.8L17.7,12.6z M17.1,2.9V4L12.4,9L9.8,7.7l-0.3,0
						l-5.6,3.6V2.9H17.1z M3.9,12.4v-0.3l5.8-3.7l2.1,1.1l-1.8,1.2l0.3,0.5l2.2-1.4l0.1,0l4.5-4.8v7.5H3.9z"
            />
            <path
              d="M6.7,7.3c0.9,0,1.7-0.8,1.7-1.7l0,0c0,0,0,0,0,0c0-0.9-0.8-1.7-1.7-1.7S5,4.7,5,5.6c0,0,0,0,0,0l0,0
						C5,6.5,5.8,7.3,6.7,7.3z M6.7,4.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C5.6,5,6.1,4.5,6.7,4.5z"
            />
          </g>
          <g>
            <path d="M1.8,5.5l-1.5,2c-0.1,0.1-0.1,0.3,0,0.4l1.5,2l0.5-0.4L0.9,7.6l1.4-1.8L1.8,5.5z" />
            <path d="M20.8,7.4l-1.5-2l-0.5,0.4l1.4,1.8l-1.4,1.8l0.5,0.4l1.5-2C20.8,7.7,20.8,7.5,20.8,7.4z" />
          </g>
          <g>
            <path
              d="M7.4,14.8c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.4C6.9,14.2,6.9,14,7,14c0.2-0.2,0.5-0.2,0.7,0
						c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4C7.6,14.8,7.5,14.8,7.4,14.8z"
            />
            <path
              d="M11.6,14.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5l0,0
						C11.8,14.8,11.6,14.6,11.6,14.3z M10,14.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5l0,0
						C10.3,14.8,10,14.6,10,14.3z M8.4,14.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5l0,0
						C8.7,14.8,8.4,14.6,8.4,14.3z"
            />
            <path
              d="M13.7,14.8c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0.1-0.3c0.2-0.2,0.5-0.2,0.7,0
						c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4C14,14.8,13.8,14.8,13.7,14.8z"
            />
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleSlideshow.js